import { z } from 'zod'

// TanStack Router may coerce OAuth success strings to booleans.
export const onboardingSearchSchema = z.object({
  success: z
    .union([z.string(), z.boolean()])
    .optional()
    .transform((value) =>
      value === true || value === 'true'
        ? 'true'
        : value === false || value === 'false'
          ? 'false'
          : value,
    ),
  account: z.string().optional(),
  subscription: z.string().optional(),
  error: z.string().optional(),
  code: z.string().optional(),
  manual: z.string().optional(),
})
